export const GRAPHQL_ENDPOINT = '/api/graphql';
export const LOGIN_ENDPOINT = '/api/signIn';
export const LOGOUT_ENDPOINT = '/api/signOut';
